import React from 'react'
import { Link, Navigate, useParams } from 'react-router-dom'
import ErrorLogList from '../../components/logs/ErrorLogList';
import ErrorLogDetail from '../../components/logs/ErrorLogDetail';
import ServiceApiLogList from '../../components/logs/ServiceApiLogList';
import ServiceApiLogDetail from '../../components/logs/ServiceApiLogDetail';

const LOG_PAGES = [
  { label: "Error Logs", desc: "Server errors and warnings raised while handling requests", icon: "bi-bug-fill", tint: "#d64545", bg: "#fdecec", to: "/logs/error" },
  { label: "Service API Logs", desc: "Calls made by agents to the service API, with status and duration", icon: "bi-hdd-network-fill", tint: "var(--btn-bg)", bg: "#eeecff", to: "/logs/service-api" },
];

const LogsHome = () => (
  <section className="section dashboard">
    <style>{`
      .logs-tile { background: #fff; border: 1px solid #d5dbe8; border-radius: 14px; padding: 20px; transition: border-color .15s, box-shadow .15s, transform .15s; }
      .logs-tile:hover { border-color: #c9c2fb; box-shadow: 0 6px 18px rgba(14,106,150, .14); transform: translateY(-2px); }
      .logs-tile:hover .logs-tile-arrow { color: var(--btn-bg) !important; transform: translateX(2px); }
      .logs-tile-arrow { transition: color .15s, transform .15s; }
    `}</style>

    <div className="mb-3">
      <h4 className="m-0 fw-bold" style={{ color: "var(--page-heading)", fontSize: 20 }}>Logs</h4>
      <nav className="d-flex align-items-center gap-1 mt-1" style={{ fontSize: 12, color: "#475569" }}>
        <Link to="/dashboard" style={{ color: "#475569" }}><i className="bi bi-house-door"></i></Link>
        <i className="bi bi-chevron-right" style={{ fontSize: 9 }}></i>
        <span className="fw-semibold" style={{ color: "#4a5568" }}>Logs</span>
      </nav>
    </div>

    <div className="row g-3">
      {LOG_PAGES.map((item) => (
        <div key={item.to} className="col-12 col-md-6">
          <Link to={item.to} className="logs-tile d-flex align-items-center gap-3 h-100 text-decoration-none">
            <span className="d-flex align-items-center justify-content-center flex-shrink-0"
              style={{ width: 52, height: 52, borderRadius: 14, background: item.bg, color: item.tint, fontSize: 22 }}>
              <i className={`bi ${item.icon}`}></i>
            </span>
            <span className="flex-grow-1" style={{ minWidth: 0 }}>
              <span className="d-block fw-bold" style={{ fontSize: 15, color: "#1a202c" }}>{item.label}</span>
              <span className="d-block" style={{ fontSize: 12, color: "#475569" }}>{item.desc}</span>
            </span>
            <i className="bi bi-chevron-right logs-tile-arrow flex-shrink-0" style={{ fontSize: 14, color: "#b4bdd0" }}></i>
          </Link>
        </div>
      ))}
    </div>
  </section>
);

const Logs = () => {
  let { method, id } = useParams();

  if (!method) return <LogsHome />;
  if (id) {
    if (method == "error") return <ErrorLogDetail />;
    if (method == "service-api") return <ServiceApiLogDetail />;
    return <Navigate to="/logs" replace />;
  }
  return (
    <>
      {method == "error" && <ErrorLogList />}
      {method == "service-api" && <ServiceApiLogList />}
      {method != "error" && method != "service-api" && <Navigate to="/logs" replace />}
    </>
  )
}

export default Logs
